import {
  Box,
  Container,
  Text,
  Grid,
  GridItem,
  Heading,
  Center,
} from "@chakra-ui/react";
import { Stack } from "@chakra-ui/react";
import successImg from "@root/public/images/photos/clarifayo_acertar.jpg";
import growthImg from "@root/public/images/photos/clarifayo_learn.jpg";
import parentChildImg from "@root/public/images/photos/clarifayo_pai-filho.jpg";
import { ScheduleFreeDiscoveryCallButton } from "./ScheduleFreeDiscoveryCallButton";
import { useTranslations } from "next-intl";
import { DashDivider } from "../LandingPage/DashDivider";
import { NestIcon } from "../LandingPage/NestIcon";

export const CoacheeDoMore = () => {
  const t = useTranslations("CoacheePage");
  return (
    <Box bgColor="brand.900" color="brand.1000">
      <Container maxW="container.xl">
        <Stack
          gap={{ base: 8, md: 8 }}
          pt={{ base: 24, md: 24 }}
          px={{
            base: 8,
            md: 20,
          }}
          pb={{ base: 8, md: 12 }}
          position="relative"
          className="landing-page"
        >
          <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={8} mb={8}>
            <Heading as="h2" size="xl" fontWeight="bold">
              {t("unlockYourPotential")}
            </Heading>
            <Text fontSize="xl" maxW="600px">
              {t("discoverThePowerOfCoaching")}
            </Text>
          </Grid>

          <Center flexDirection={"column"} gap={8}>
            <NestIcon width={80} height={40} />
            <DashDivider />
          </Center>

          <Grid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }} gap={8}>
            {[
              {
                image: growthImg.src,
                word: t("benefits.growth"),
              },
              {
                image: successImg.src,
                word: t("benefits.success"),
              },
              {
                image: parentChildImg.src,
                word: t("benefits.impact"),
              },
            ].map((item, index) => (
              <GridItem key={index}>
                <Box
                  position="relative"
                  borderRadius="xl"
                  overflow="hidden"
                  height="300px"
                  _before={{
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    bg: "blackAlpha.600",
                    zIndex: 1,
                  }}
                >
                  <Box
                    position="absolute"
                    top={0}
                    left={0}
                    right={0}
                    bottom={0}
                    backgroundImage={`url(${item.image})`}
                    backgroundSize="cover"
                    backgroundPosition="center"
                  />
                  <Box
                    position="absolute"
                    top={0}
                    left={0}
                    right={0}
                    bottom={0}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    zIndex={2}
                  >
                    <Text
                      fontSize="3xl"
                      fontWeight="bold"
                      color="white"
                      textTransform="uppercase"
                    >
                      {item.word}
                    </Text>
                  </Box>
                </Box>
              </GridItem>
            ))}
          </Grid>
          <Center flexDirection={"column"} mt={4} gap={8}>
            <DashDivider />
            <ScheduleFreeDiscoveryCallButton
              label={t("talkToOurTeam")}
              variant="secondary"
            />
          </Center>
        </Stack>
      </Container>
    </Box>
  );
};
